import styled from "styled-components";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Main = styled.main`
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  padding: 48px 20px 60px;
  color: ${({ theme }) => theme.text_primary};
`;

const Title = styled.h1`
  font-size: clamp(28px, 6vw, 42px);
`;

const HomeLink = styled(Link)`
  color: ${({ theme }) => theme.primary};
  font-weight: 600;
`;

const NotFound = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Page not found | Saroj Giri";
    let robots = document.querySelector('meta[name="robots"]');
    const previous = robots?.getAttribute("content") || "index, follow, max-image-preview:large";
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex");
    return () => {
      document.title = previousTitle;
      robots.setAttribute("content", previous);
    };
  }, []);

  return (
    <Main>
      <Helmet>
        <title>Page not found | Saroj Giri</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Title>This page does not exist</Title>
      <HomeLink to="/">Back to the portfolio</HomeLink>
    </Main>
  );
};

export default NotFound;
